import React from "react";
import { addOrUpdateBooking } from "../../../../../../APIs/Booking/UpdateBooking";
import { useDiaryContext } from "../../../../../../hooks/useDiaryContext";
import { updateBooking } from "../SelectedBookingManageController";

const Stages = () => {
  const diaryContext = useDiaryContext();
  const { selectedBooking, bookings, stages, setDiaryContext } = diaryContext;

  if (!selectedBooking || !bookings) {
    return null;
  }

  return (
    <div className="Stages pt-[var(--panelPadding)] mb-[var(--panelPadding)]">
      <div className="Stages-Title font-bold pt-[var(--panelPadding)] text-[length:var(--fontSize-base)]">
        Booking Stage
      </div>
      <div className="Stages-Container mt-[var(--panelPadding)] rounded-toggle bg-page-background-secondary flex w-full flex-wrap overflow-visible p-px">
        <div className="Stages-ButtonGroup rounded-toggle bg-page-background-secondary flex w-full flex-wrap overflow-visible">
          {stages?.map((stage) => (
            <button
              type="button"
              className={[
                "Stages-Button inline-flex items-center justify-center w-[33%] grow p-2.5 text-collins-md font-bold transition-[background] duration-100 ease-in-out bg-[var(--grid-background)] relative m-px",
                selectedBooking.currentStage === stage.id
                  ? "selected [&>span]:z-[1] [&>span]:text-button-primary-foreground [[data-theme='Light']_&>span]:text-black"
                  : ""
              ]
                .filter(Boolean)
                .join(" ")}
              key={`stage-${stage.id}`}
              onClick={() => {
                const { updatedBookings, updatedBooking } = updateBooking({
                  selectedBooking,
                  bookings,
                  bookingPropsToSave: {
                    currentStage: stage.id
                  }
                });

                setDiaryContext({ bookings: updatedBookings });
                addOrUpdateBooking({
                  booking: updatedBooking,
                  diaryContext
                });
              }}
            >
              <div
                className="backgroundEffect absolute left-0 w-full h-full [.selected>&]:after:content-[''] [.selected>&]:after:absolute [.selected>&]:after:left-0 [.selected>&]:after:w-full [.selected>&]:after:h-full [.selected>&]:after:bg-white/50"
                style={{
                  backgroundColor:
                    selectedBooking.currentStage === stage.id
                      ? `#${stage.colour}`
                      : undefined
                }}
              />
              <span>{stage.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Stages;
